import(/* webpackMode: "eager", webpackExports: ["AppRouterI18nProvider"] */ "/app/apps/web/app/AppRouterI18nProvider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Providers"] */ "/app/apps/web/app/providers.tsx");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/script.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/font/google/target.css?{\"path\":\"app/layout.tsx\",\"import\":\"Inter\",\"arguments\":[{\"subsets\":[\"latin\"],\"variable\":\"--font-inter\",\"preload\":true,\"display\":\"swap\"}],\"variableName\":\"interFont\"}");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/font/local/target.css?{\"path\":\"app/layout.tsx\",\"import\":\"\",\"arguments\":[{\"src\":\"../fonts/CalSans-SemiBold.woff2\",\"variable\":\"--font-cal\",\"preload\":true,\"display\":\"block\",\"weight\":\"600\"}],\"variableName\":\"calFont\"}");
;
import(/* webpackMode: "eager" */ "/app/apps/web/styles/globals.css");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/node_modules/react-inlinesvg/dist/index.mjs");
